import { render } from "./adminPasswordReset.vue?vue&type=template&id=39b73860&scoped=true"
import script from "./adminPasswordReset.vue?vue&type=script&lang=js"
export * from "./adminPasswordReset.vue?vue&type=script&lang=js"

import "./adminPasswordReset.vue?vue&type=style&index=0&id=39b73860&scoped=true&lang=css"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b73860"]])

export default __exports__